export const PSC_dialog_msg = {
    "ja": [
        "{0}を以下に変更しました。",       //0
        "ファイルアップロードに成功しました。",
        "ファイルアップロード時にエラーが発生しました。管理者へお問い合わせください。",
        "検索結果が多すぎます。期間や範囲など検索条件を絞って再度お試しください。",
        "変更時にエラーが発生しました。管理者へお問い合わせください。",
        "エラーが発生しました。管理者へお問い合わせください。",     //5
        "ファイルが選択されていません。",
        "ファイルのフォーマットが正しくありません。",
        "ファイルダウンロード時にエラーが発生しました。管理者へお問い合わせください。",
        "{0}を{1}に変更しました。",
        "検索中にタイムアウトが発生しました。再度お試しください。",//10
        "検索に時間がかかっています。期間や範囲以外の検索条件を追加してください。",
        "検索に失敗しました。しばらく時間をおいてから再度検索をお願いします。"
    ],
    "en": [
        "{0} has been changed as follows:",       //0
        "File upload successful.",
        "An error occurred while uploading the file. Please contact the administrator.",
        "Too many search results. Please narrow down the search criteria such as period and range and try again.",
        "An error occurred during the change. Please contact the administrator.",
        "An error occurred. Please contact the administrator.",     //5
        "File is not selected.",
        "The format of the file is incorrect.",
        "An error occurred while downloading the file. Please contact the administrator.",
        "Changes from {0} to {1} are complete.",
        "A timeout occurred during the search. Please try again.",//10
        "Searching is taking a long time. Please add search conditions other than date range and range.",
        "Search failed. Please search again after a while."
    ]
};

export const PSC_dialog_label = {
    "ja": [
        "閉じる",
        "変更確認",
        "アップロード結果",
        "メッセージ",
        "同意する",
    ],
    "en": [
        "Close",
        "Confirm change",
        "Upload result",
        "Message",
        "同意する",
    ]
};

